import {Component, computed, effect, signal, TemplateRef, ViewChild} from '@angular/core';
import {
    ArchivoItem, ArchivoTipoEnum,
    CatalogoInterface,
    FileCase,
    RequisitosFormulario, TenenciaEnum, TenenciaItem
} from '../../../../../interfaces/proyecto.interface';
import {catchError, throwError} from 'rxjs';
import {MessageService} from 'primeng/api';
import {HttpClient} from '@angular/common/http';
import {FileUtilsService} from "../../../../../../shared/services/file-utils-service";
import {FileUpload} from "primeng/fileupload";
import {NuevoProyectoComponent} from "../../nuevo-proyecto.component";
import {defaultProyectoPerfil, ProyectoPerfil} from "../../../../../interfaces/perfil.interface";
import {PersonasService} from "../../../../../../shared/services/personas-service";
import {RequisitoService} from "../../../../../mnto-requisitos/services/requisito.service";
import {CatalogoService} from "../../../../../../shared/services/catalogo-service";
import Swal from "sweetalert2";
import {PasosPersonasService} from "../../services/pasos-personas.service";
import {DraftProjectService} from "../../../../services/draft-project.service";
@Component({
    selector: 'tenencia-inmueble-proyecto',
    templateUrl: './personas-proyecto.component.html',
    styleUrls: ['./personas-proyecto.component.css'],
})
export class PersonasProyectoComponent{
    tenencias: TenenciaItem[] = []
    tenenciaCatalogo: TenenciaItem[] = []
    personaEncontradaTemp: ProyectoPerfil = null!
    limpiarBusquedaPersona: boolean = false
    hashDelArchivo: any = null
    showCargarEscritura: boolean = false
    buttonPropietario: Boolean = false;
    tenenciaArchivoTipo: CatalogoInterface[] = []
    planosRequisitos: RequisitosFormulario[] = [];
    requisitosFormulario: RequisitosFormulario[] = [];
    dataFileSeleted: ArchivoItem[] = [];
    openDialog: boolean = false;
    templateResponse!: TemplateRef<any>;
    validateRunEffect = signal(true);
    @ViewChild('cargaArchivos') fileUpload: FileUpload | any;
    // @ViewChild('consultaUsuario') consultaUsuario!: ConsultaUsuarioComponent; //variable para obtener solo el template del hijo que se necesita ocupar
    constructor(private http: HttpClient, private messageService: MessageService, private catalogoService: CatalogoService,
                public datosProyecto: NuevoProyectoComponent, protected fileUtilsService: FileUtilsService, public personasService: PersonasService,
                private requisitoService: RequisitoService, private tenenciaService:PasosPersonasService,protected draftProjectService : DraftProjectService) {
        effect(() => {
            if (this.personasService.selected() != null) {
                if (this.personaEncontradaTemp == null) {
                    this.personaEncontradaTemp = defaultProyectoPerfil();
                }
                this.personaEncontradaTemp.personaInfo = this.personasService.selected();
                this.personaEncontradaTemp.uniqueId = this.personasService.selected().uniqueId;
                this.personaEncontradaTemp.idPersona = Number.parseInt(this.personasService.selected().idPersona);
                this.buttonPropietario = false
                console.log('this.personasService.selected() ->', JSON.stringify(this.personasService.selected()));
                console.log('this.personaEncontradaTemp      ->', JSON.stringify(this.personaEncontradaTemp));
            }
        });
    }

    ngOnInit(): void {
        // this.getTenencia();
        this.getTipoArchivos();
        this.getRequisitosFormulario();
    }
    /**
     *Este metodo obtiene los idTipoArchivo para los diferentes pasos tenencia legal, representante legal y planos
     * La informacion se guarda en ARCHIVOS_PROYECTO, TENENCIA_PROYECTO y SOLICITUD_DETALLE_RE que se procesa desde el FU.
     *El metodo se utiza para agregar la informacion la lista personaEncontradaTemp
     */
    obtenerTipoArchivo(items: CatalogoInterface[] | null) {
        if ((!items || items.length === 0)) {
            return null;
        }
        let obtenerId: string | number | null = null;
        /** Caso 1:*/
        if (this.datosProyecto.activeStep == 2) {
            /**
             *Obtener el idTipoArchivo que se va cargar y que selecciona en tenencia legal*/
            if (items && items.length > 0) {
                switch (this.idTenencia) {
                    case "6":
                        obtenerId = items.find(tipo => tipo.id === ArchivoTipoEnum.Prominentecomprador.toString() || tipo.descripcion === 'Prominente Comprador')?.id || null;
                        break;
                    case "3":
                        obtenerId = items.find(tipo => tipo.id === ArchivoTipoEnum.Escrituramatrizcompraventa.toString() || tipo.descripcion === 'Escritura matriz compra-venta')?.id || null;
                        break;
                    case "2":
                        obtenerId = items.find(tipo => tipo.id === ArchivoTipoEnum.Contratodearrendamiento.toString() || tipo.descripcion === 'Contrato de arrendamiento')?.id || null;
                        break;
                    case "1":
                        obtenerId = items.find(tipo => tipo.id === ArchivoTipoEnum.Contratodecomodato.toString() || tipo.descripcion === 'Contrato de comodato')?.id || null;
                        break;
                    default:
                        break;
                }
            }
        }
        /** Caso 2:*/
        if (this.datosProyecto.activeStep == 3) {
            /**
             Obtener el idTipoArchivo que se va cargar para el representante legal
             */
            if (items && items.length > 0) {
                obtenerId = items.find(tipo => tipo.id === ArchivoTipoEnum.Representantelegal.toString() || tipo.descripcion === 'Representante legal')?.id || null;
            }
        }
        /** Caso 3:*/
        if (this.datosProyecto.activeStep == 4) {
            if (this.planos != null) {
                /**
                 Obtener el idTipoArchivo que se va cargar para los planos
                 */
                if (items && items.length > 0) {
                    obtenerId = items.find(tipo => tipo.id === ArchivoTipoEnum.Planosactuales.toString() || tipo.descripcion === 'Planos actuales')?.id || null;
                }
            }
        }
        return obtenerId;
    }

    validacionButton(): boolean {
        return (this.datosProyecto.activeStep === 2 && !this.tenencia) ||
            (this.datosProyecto.activeStep === 4 && !this.planos || !this.personasService.selected()) ||
            (this.datosProyecto.activeStep == 3 && !this.personasService.selected())
    }

    onDialogClosed(event: boolean) {
        this.openDialog = event;
    }

    onFileCheck(event: any) {
        this.dataFileSeleted = event;
        this.procesarPersonaEncontradaArchivo(FileCase.ReuseFile)
    }

    openDialogFile() {
        this.openDialog = true;
    }

    /*
     gets
     */
    get tenencia() {
        return this.datosProyecto.tenenciaSeleccionada
    }

    get idTenencia() {
        return (this.datosProyecto.tenenciaSeleccionada ? this.datosProyecto.tenenciaSeleccionada.idTenencia.toString() : null)
    }

    get camposCompletos() {
        return this.datosProyecto.datosCompletosTenencia
    }

    get planos() {
        return this.datosProyecto.selectPlanosRequisito
    }

    getTipoPlanos() {
        this.requisitoService.getActivosRequisitoPlanos().pipe(
            catchError(error => {
                const status = error.status
                if (status == '400' || status == '404') {
                    this.messageService.add({
                        severity: 'error', summary: '',
                        detail: 'Error al obtener la información de los planos'
                    });
                }
                return throwError(error.statusText);
            })
        )
            .subscribe(resp => {
                this.planosRequisitos = resp;
            });
    }

    // getTenencia() {
    //     this.tenenciaService.getTenenciaList([])
    //         .pipe(
    //             catchError(error => {
    //                 const status = error.status
    //                 if (status == '400' || status == '404') {
    //                     this.messageService.add({
    //                         severity: 'error', summary: '', detail: 'Error al obtener la información de tenencias'
    //                     });
    //                 }
    //                 return throwError(error.statusText);
    //             })
    //         )
    //         .subscribe(
    //             resp => {
    //                 this.tenenciaCatalogo = resp;
    //                 this.getFilterTenenciaLegal(resp);
    //             }
    //         )
    // }

    getTipoArchivos() {
        this.catalogoService.getCatalogo("archivo_tipo")
            .subscribe({
                next: (result) => {
                    this.tenenciaArchivoTipo = result;
                },
                error: (error) => {
                },
                complete: () => {
                    console.log(`archivo_tipo ->` + this.constructor.name)
                }
            });
    }

    getRequisitosFormulario() {
        this.requisitoService.getActivosRequisitosFormulario().pipe(
            catchError(error => {
                const status = error.status
                if (status == '400' || status == '404') {
                    this.messageService.add({
                        severity: 'error', summary: '',
                        detail: 'Error al obtener la información de requisitos formulario único'
                    });
                }
                return throwError(error.statusText);
            })
        )
            .subscribe(
                {
                    next: (result) => {
                        if (result) {
                            this.requisitosFormulario = result
                            this.getTipoPlanos();
                        }
                    },
                    error: (error) => {
                        console.log(error)
                    },
                    complete: () => {
                    }
                }
            )
    }

    /**Obteniendo lista de tenencias que se seleccionan en el paso tenencia legal*/
    getFilterTenenciaLegal(tenenciaCatalogo: TenenciaItem[] = []) {
        this.tenencias = tenenciaCatalogo.filter(tipo => tipo.idTenencia.toString() === TenenciaEnum.Conmodato || tipo.descripcion === 'COMODATO' ||
            tipo.idTenencia.toString() === TenenciaEnum.Arrendatario || tipo.descripcion === 'ARRENDATARIO' ||
            tipo.idTenencia.toString() === TenenciaEnum.Propietario || tipo.descripcion === 'PROPIETARIO')
    }

    /**filtro que obtiene id de los requisitos relacionados con la tenencia*/
    getIdRequisito(tipo: TenenciaEnum) {
        console.log("resultado getIdRequisito ",this.tenenciaCatalogo.find(tenencia => tenencia.idTenencia.toString() === tipo)?.idRequisito!)
        return this.tenenciaCatalogo.find(tenencia => tenencia.idTenencia.toString() === tipo)?.idRequisito!;
    }
    /**filtro que obtiene los id de tenencia*/
    getIdTenencia(tipo: TenenciaEnum) {
        console.log("resultado getIdTenencia ",this.tenenciaCatalogo.find(tenencia => tenencia.idTenencia.toString() === tipo)?.idTenencia!)
        return this.tenenciaCatalogo.find(tenencia => tenencia.idTenencia.toString() === tipo)?.idTenencia!;
    }

    getArchivosParam(tipos: string[], uniqueId: string) {
        this.personasService.getObtenerArchivosPersona(tipos, uniqueId);
    }

    /*
     sets
     */
    setTenencia(tenencia: TenenciaItem | null) {
        if (tenencia) {
            console.log("setTenenciaa->",tenencia)
            this.showCargarEscritura = (tenencia.idTenencia.toString() === TenenciaEnum.Propietario);
            this.datosProyecto.tenenciaSeleccionada = tenencia;
            this.buttonPropietario = true;
        } else {
            this.showCargarEscritura = false;
            this.datosProyecto.tenenciaSeleccionada = null;
            this.buttonPropietario = false;
        }
    }

    setPlanosTipo(planos: RequisitosFormulario) {
        this.datosProyecto.selectPlanosRequisito = planos
        this.buttonPropietario = true;
    }
    setOnResponseUserEmitter(template: TemplateRef<any>){
        console.log("setOnResponseUserEmitter->",template)
        this.templateResponse=template
  }
    agregarPropietario(autoAgregar: boolean = false) {
        console.log(`autoAgregar: ${autoAgregar}`)
        console.log(`this.fileUtilsService.file: `, this.fileUtilsService.file)
        if (!this.fileUtilsService.file) {
            this.messageService.add({
                severity: 'error', summary: '',
                detail: 'Error al agregar los datos, favor cargar el archivo.'
            });
            return;
        }
        this.procesarPersonaEncontradaArchivo(FileCase.FileUpload);
    }

    procesarPersonaEncontradaArchivo(caso: number) {
        try {
            console.log("#######################################################")
            console.log(`activeIndex:` + this.datosProyecto.activeIndex)
            console.log("#######################################################")
            let idTipoArchivo = this.obtenerTipoArchivo(this.tenenciaArchivoTipo)!;
            if (!idTipoArchivo) {
                Swal.fire({
                    position: "center",
                    icon: "error",
                    title: "Tipo de archivo no válido o no permitido",
                    showConfirmButton: true,
                }).then((result) => {
                    console.log("Tipo de archivo no válido o no permitido")
                });
            }
            if (this.datosProyecto.activeStep == 2) {
                this.personaEncontradaTemp['tipo_propietario'] = this.datosProyecto.tenenciaSeleccionada != null ? this.datosProyecto.tenenciaSeleccionada.descripcion : ''
                this.personaEncontradaTemp['idTenencia'] = (this.datosProyecto.tenenciaSeleccionada != null ? this.datosProyecto.tenenciaSeleccionada.idTenencia : 0);
                if (this.idTenencia == TenenciaEnum.Propietario) {
                    this.personaEncontradaTemp['idTipoArchivo'] = idTipoArchivo;
                    this.personaEncontradaTemp["idRequisito"] = this.datosProyecto.tenenciaSeleccionada?.idRequisito!;
                } else if (this.idTenencia == TenenciaEnum.Arrendatario) {
                    this.personaEncontradaTemp['idTipoArchivo'] = idTipoArchivo;
                    this.personaEncontradaTemp["idRequisito"] = this.datosProyecto.tenenciaSeleccionada?.idRequisito!;
                } else if (this.idTenencia == TenenciaEnum.Conmodato) {
                    this.personaEncontradaTemp['idTipoArchivo'] = idTipoArchivo;
                    this.personaEncontradaTemp["idRequisito"] = this.datosProyecto.tenenciaSeleccionada?.idRequisito!;
                }else if (this.idTenencia == TenenciaEnum.ProminenteComprador) {
                    this.personaEncontradaTemp['idTipoArchivo'] = idTipoArchivo;
                    this.personaEncontradaTemp["idRequisito"] = this.datosProyecto.tenenciaSeleccionada?.idRequisito!;
                } else {
                    console.error(`error en la tenencia seleccionada`);
                }
            }
            if (this.datosProyecto.activeStep == 3) {
                this.personaEncontradaTemp['tipo_propietario'] = 'N/A'
                this.personaEncontradaTemp['idTenencia'] = this.getIdTenencia(TenenciaEnum.RepresentanteLegal)!;
                this.personaEncontradaTemp['idTipoArchivo'] = idTipoArchivo;
                this.personaEncontradaTemp["idRequisito"] = this.getIdRequisito(TenenciaEnum.RepresentanteLegal)!;
            }
            if (this.datosProyecto.activeStep == 4) {
                this.personaEncontradaTemp['tipo_propietario'] = ''
                this.personaEncontradaTemp['idTenencia'] = this.getIdTenencia(TenenciaEnum.Profesionales)!;
                this.personaEncontradaTemp['idTipoArchivo'] = idTipoArchivo;
                this.personaEncontradaTemp["idRequisito"] = this.datosProyecto.selectPlanosRequisito?.idRequisito;
            }
            if (this.hashDelArchivo !== null && this.fileUtilsService.file && caso === FileCase.FileUpload!) {
                //Caso 1: archivos que se cargan mediante el fileUpload
                this.personaEncontradaTemp['archivo'] = this.fileUtilsService.file
                this.personaEncontradaTemp['hash'] = this.hashDelArchivo
                this.personaEncontradaTemp['nombreArchivo'] = this.fileUtilsService.file.name
                this.personaEncontradaTemp['idPasoGeneralidades'] = this.datosProyecto.activeStep;
                this.personaEncontradaTemp['caso'] = caso;
                console.log('archivoSeleccionado-> ', this.fileUtilsService.file);
                console.log('hashDelArchivo-> ', this.hashDelArchivo);
            } else if (this.dataFileSeleted.length > 0 && this.dataFileSeleted[0].hash !== null && this.dataFileSeleted[0].hash !== ""
                && caso === FileCase.ReuseFile!) {
                //Caso 2: archivos que se seleccionan mediante el dialog
                this.personaEncontradaTemp['hash'] = this.dataFileSeleted[0].hash
                this.personaEncontradaTemp['nombreArchivo'] = this.dataFileSeleted[0].nombre
                this.personaEncontradaTemp['idPasoGeneralidades'] = this.datosProyecto.activeStep;
                this.personaEncontradaTemp['caso'] = caso;
                console.log('hashDelArchivo-> ', this.dataFileSeleted[0].hash);
            }
            // Obtener el hash del archivo que se desea agregar a la lista temporal y se previsualizan en la tabla
            const hashExistente = this.draftProjectService.draftProject().tenenciaLegal.some(prop => prop.hash === this.personaEncontradaTemp.hash);
            if (!hashExistente) {
                this.draftProjectService.draftProject().tenenciaLegal.push({...this.personaEncontradaTemp});
                this.personaEncontradaTemp = null!;
                this.limpiarBusquedaPersona = true;
                this.datosProyecto.banderaBotonConfirmar = false;
                this.buttonPropietario = true;
            } else {
                this.messageService.add({
                    severity: 'error', summary: '',
                    detail: 'Error al agregar archivo, ya existe este archivo agregado'
                });
                this.fileUpload.clear(); //limpiando para cargar otro archivos
                this.buttonPropietario = true;
            }
            console.log('this.personaEncontradaTemp ->', JSON.stringify(this.personaEncontradaTemp));
            console.log("this.draftProjectService.draftProject().tenenciaLegal-> ", JSON.stringify(this.draftProjectService.draftProject().tenenciaLegal));
            this.fileUpload.clear(); //limpiando para cargar otro archivos
            this.personasService.limpiarSeleccion();
            setTimeout(() => {
                this.limpiarBusquedaPersona = false
                this.buttonPropietario = true;
            }, 2000)
        } catch (e) {
            console.log(e)
        }
    }

    async onFileUpload(event: any) {
        const estado = await this.fileUtilsService.fileUploadToBuffer(event, this.fileUpload);
        this.hashDelArchivo = this.fileUtilsService.hash;
        if (estado != 1) {
            this.messageService.add({
                severity: 'error', summary: '',
                detail: 'Archivo no cargado, fallo el proceso de carga'
            });
            this.buttonPropietario = true;
            this.fileUpload.clear();
            return;
        }
        this.agregarPropietario(true);
        this.buttonPropietario = true;
        this.fileUpload.clear();
        console.log("Resultado verificación:-> ", estado);
    }

    effectSelected = effect(() => {
        if (this.validateRunEffect() && this.personasService.selected() !== null) {
            let idTipoArchivo: string[] = [this.obtenerTipoArchivo(this.tenenciaArchivoTipo)?.toString()!];
            this.getArchivosParam(idTipoArchivo, this.personasService.selected()?.uniqueId);
        }

    }, {allowSignalWrites: true});

    countFile = computed(() => {
        if (this.personasService.selected() && this.personasService.selected()?.uniqueId != null) {
            return this.personasService.archivos()?.length;
        }
        return 0;
    });

}
